export const url = "https://chatapi.jrdn.tech";
